/**
 * アコーディオン - コンポーネント
 * @see ABUI_doc__Component_Accordion.html
 */
if (typeof abuiAccordion === 'undefined') {
  /**
   * アコーディオン オブジェクト
   * @type {Object}
   */
  var abuiAccordion = {
    /**
     * アコーディオンの動作
     * @param  {Object} _this クリックしたボタン
     */
    behavior: function(_this) {
      const onClickAccordion = $(_this);
      onClickAccordion.find('.icon').toggleClass('icon-abui-arrow-right').toggleClass('icon-abui-arrow-down');
      onClickAccordion.closest('.js-accordion').find('.js-toggle-content').eq(0).slideToggle('fast');
      onClickAccordion.children('.js-toggle-txt').toggle();
    }
  };
}